import { Dispatch, SetStateAction } from "react";
import { bodyStore } from "@/store/bodyStore";
import { BodyPart, PartName } from "@/types/design";
import { selectingPartStore } from "@/store/partsStore";

type PartMenuArg = {
	setShowPalette: Dispatch<SetStateAction<boolean>>;
	setShowPartMove: Dispatch<SetStateAction<boolean>>;
};

// パーツメニュー コンポーネントで使うロジックを提供します。
export default function usePartMenu(arg: PartMenuArg) {
	const { setShowPalette, setShowPartMove } = arg;
	const { body } = bodyStore();
	const { setSelectingPart } = selectingPartStore();

	// パーツメニュークリック時の処理
	const onPartMenuClick = (partName: PartName) => {
		// 選択中のパーツを管理する
		const targetPart = body.find((m: BodyPart) => m.partName === partName);
		const partId = targetPart ? targetPart.partId : undefined;
		setSelectingPart({ partId, partName });

		// パーツメニューが切り替わった場合パレットを閉じる
		setShowPalette(false);
		setShowPartMove(false);
	};

	return {
		onPartMenuClick,
	};
}
